<op-user-autocompleter
  class="inline-edit--field {{ handler.fieldName }}"
  *ngIf="url"
  [multiple]="true"
  [url]="url"
  [inviteUserToProject]="resource.project?.id"
  [focusDirectly]="!(handler.inEditMode || isNew)"
  [openDirectly]="!(handler.inEditMode || isNew)"
  appendTo="body"
  [model]="value"
  [id]="handler.htmlId"
  (change)="onModelChanges($event)"
  (cancel)="handler.handleUserCancel()"
  (userInvited)="onUserInvited($event)"
></op-user-autocompleter>
